<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="类型名称">
                <a-input v-model="queryParam.keyword" placeholder="名称/编码" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" placeholder="全部" allow-clear style="width: 100%">
                  <a-select-option value="enabled">启用</a-select-option>
                  <a-select-option value="disabled">停用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['erp:customerCategory:add']">
          <a-icon type="plus" />新增
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <create-form ref="createForm" :parent-options="parentOptions" @ok="getList" />

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :defaultExpandAllRows="true"
      >
        <span slot="status" slot-scope="text, record">
          <a-tag :color="record.status === 'enabled' ? 'green' : 'red'">
            {{ record.status === 'enabled' ? '启用' : '停用' }}
          </a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['erp:customerCategory:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['erp:customerCategory:add']" />
          <a @click="$refs.createForm.handleAdd(record)" v-hasPermi="['erp:customerCategory:add']">
            <a-icon type="plus" />新增
          </a>
          <a-divider type="vertical" v-hasPermi="['erp:customerCategory:status']" />
          <a
            v-if="record.status === 'enabled'"
            @click="handleDisable(record)"
            v-hasPermi="['erp:customerCategory:status']"
          >停用</a>
          <a
            v-else
            @click="handleEnable(record)"
            v-hasPermi="['erp:customerCategory:status']"
          >启用</a>
          <a-divider type="vertical" v-hasPermi="['erp:customerCategory:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['erp:customerCategory:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  treeCustomerCategory,
  enableCustomerCategory,
  disableCustomerCategory,
  deleteCustomerCategory
} from '@/api/erp/customerCategory'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CustomerCategory',
  components: { CreateForm },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      allList: [],
      parentOptions: [],
      loading: false,
      queryParam: {
        keyword: undefined,
        status: undefined
      },
      columns: [
        { title: '类型名称', dataIndex: 'categoryName' },
        { title: '类型编码', dataIndex: 'categoryCode', align: 'center' },
        { title: '层级', dataIndex: 'levelNo', align: 'center', width: 80 },
        { title: '排序号', dataIndex: 'sortNo', align: 'center', width: 80 },
        { title: '关联客户数', dataIndex: 'customerCount', align: 'center', width: 110 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center', width: 90 },
        { title: '操作', dataIndex: 'operation', width: '32%', scopedSlots: { customRender: 'operation' }, align: 'center' }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      treeCustomerCategory().then(res => {
        const tree = res.data || []
        this.allList = tree
        this.parentOptions = [{ id: 0, categoryName: '顶级目录', children: this.cloneTree(tree) }]
        this.list = this.filterTree(tree)
      }).finally(() => {
        this.loading = false
      })
    },
    cloneTree (nodes) {
      return (nodes || []).map(n => ({
        id: n.id,
        categoryName: n.categoryName,
        children: this.cloneTree(n.children)
      }))
    },
    filterTree (nodes) {
      const kw = (this.queryParam.keyword || '').trim().toLowerCase()
      const status = this.queryParam.status
      const walk = (list) => {
        const out = []
        ;(list || []).forEach(node => {
          const children = walk(node.children)
          const hitKw = !kw ||
            String(node.categoryName || '').toLowerCase().indexOf(kw) >= 0 ||
            String(node.categoryCode || '').toLowerCase().indexOf(kw) >= 0
          const hitStatus = !status || node.status === status
          if ((hitKw && hitStatus) || children.length) {
            out.push({ ...node, children })
          }
        })
        return out
      }
      return walk(nodes)
    },
    handleQuery () {
      this.list = this.filterTree(this.allList)
    },
    resetQuery () {
      this.queryParam = { keyword: undefined, status: undefined }
      this.list = this.allList
    },
    handleEnable (record) {
      enableCustomerCategory(record.id).then(res => {
        if (res.success || res.code === 20001 || res.code === 200 || res.code === '20001') {
          this.$message.success('启用成功')
          this.getList()
        } else {
          this.$message.error(res.message || '启用失败')
        }
      })
    },
    handleDisable (record) {
      const that = this
      this.$confirm({
        title: '确认停用该目录节点？',
        onOk () {
          return disableCustomerCategory(record.id).then(res => {
            if (res.success || res.code === 20001 || res.code === 200 || res.code === '20001') {
              that.$message.success('停用成功')
              that.getList()
            } else {
              that.$message.error(res.message || '停用失败')
            }
          })
        }
      })
    },
    handleDelete (record) {
      const that = this
      this.$confirm({
        title: '确认删除该目录节点？',
        content: '有下级或仍有客户引用时将无法删除',
        onOk () {
          return deleteCustomerCategory(record.id).then(res => {
            if (res.success || res.code === 20001 || res.code === 200 || res.code === '20001') {
              that.$message.success('删除成功')
              that.getList()
            } else {
              that.$message.error(res.message || '删除失败')
            }
          })
        }
      })
    }
  }
}
</script>
